import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function BeforeAfterSection() {
  const before = ['Confusión', 'Falta de dirección', 'Miedo a empezar', 'Procrastinación', 'Ideas sin ejecutar'];
  const after = ['Claridad', 'Hábitos más fuertes', 'Mentalidad enfocada', 'Uso inteligente de herramientas', 'Más acción y menos dudas'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-950" data-id="element-2">
      <div className="max-w-5xl mx-auto" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-4">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-5">
            La diferencia entre seguir esperando o empezar a transformar tu
            vida.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6">
          {/* Before Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/[0.04] backdrop-blur-sm rounded-3xl p-8 border border-white/10" data-id="element-7">
            <h3 className="text-2xl font-bold text-slate-500 mb-8 text-center" data-id="element-8">
              ANTES
            </h3>
            <ul className="space-y-6" data-id="element-9">
              {before.map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-10">
                  <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0" data-id="element-11">
                    <X className="w-5 h-5 text-slate-500" data-id="element-12" />
                  </div>
                  <span className="text-lg text-slate-500" data-id="element-13">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* After Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-pink-500/15 to-purple-500/15 rounded-3xl p-8 border border-pink-500/25 shadow-xl shadow-pink-500/10 relative overflow-hidden backdrop-blur-sm" data-id="element-14">
            <div className="absolute top-0 right-0 w-32 h-32 bg-pink-500/20 rounded-full blur-3xl opacity-50 -mr-10 -mt-10" data-id="element-15"></div>
            <h3 className="text-2xl font-bold text-pink-400 mb-8 text-center relative z-10" data-id="element-16">
              DESPUÉS
            </h3>
            <ul className="space-y-6 relative z-10" data-id="element-17">
              {after.map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-18">
                  <div className="w-8 h-8 rounded-full bg-pink-500 flex items-center justify-center flex-shrink-0 shadow-md shadow-pink-500/30" data-id="element-19">
                    <Check className="w-5 h-5 text-white" data-id="element-20" />
                  </div>
                  <span className="text-lg font-medium text-white" data-id="element-21">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}